// extracted by mini-css-extract-plugin
export var asText = "Button-module--asText--1d8e6";
export var bookingPath = "Button-module--bookingPath--7a9e6";
export var outline = "Button-module--outline--e2a95";
export var primary = "Button-module--primary--b8701";
export var primaryInvert = "Button-module--primaryInvert--66bf8";
export var wedding = "Button-module--wedding--5ad03";